import React from 'react';
import classnames from 'classnames';
import { node, oneOf, bool, string } from 'prop-types';

export const ALIGN_START = Symbol('start');
export const ALIGN_CENTER = Symbol('center');
export const ALIGN_END = Symbol('end');

const ToolbarSection = ({ children, align, shrink, className }) => (
  <section
    className={classnames(
      'mdc-toolbar__section',
      {
        'mdc-toolbar__section--align-start': align === ALIGN_START,
        'mdc-toolbar__section--align-end': align === ALIGN_END,
        'mdc-toolbar__section--shrink-to-fit': shrink,
      },
      className,
    )}
  >{children}
  </section>
);

ToolbarSection.ALIGN_START = ALIGN_START;
ToolbarSection.ALIGN_CENTER = ALIGN_CENTER;
ToolbarSection.ALIGN_END = ALIGN_END;

ToolbarSection.propTypes = {
  children: node,
  align: oneOf([ALIGN_START, ALIGN_CENTER, ALIGN_END]),
  shrink: bool,
  className: string,
};

ToolbarSection.defaultProps = {
  align: ALIGN_CENTER,
  shrink: false,
  children: null,
  className: null,
};

export default ToolbarSection;
